import AdminView from "../views/type1/AdminView";
import PartnerView from "../views/type2/PartnerView";
import CustomerUserView from "../views/type3/CustomerUserView";
import CustomerType7View from "../views/type7/CustomerType7View";
import NotAllowedView from "../views/shared/NotAllowedView";

const VIEW_BY_TYP = {
  1: AdminView,
  2: PartnerView,
  3: CustomerUserView,
  7: CustomerType7View,
};

/**
 * Resolves the view component for DSOK customer detail based on effective typ.
 * typ 1 = Admin, 2 = Partner, 3 = Customer user, 7 = Customer type 7 (service partner).
 * Caller should pass 7 when logged-in customer has customerType/customer_type === 7.
 * typ 4, 5, 6 and any unknown typ return NotAllowedView.
 * @param {number} typ - effective type (user type or 7 when customer is type 7)
 * @returns {React.Component}
 */
export function resolveDsokCustomerDetailView(typ) {
  const View = VIEW_BY_TYP[typ];
  return View || NotAllowedView;
}
